import { useEffect } from "react";

export default function Locations() {
  useEffect(() => {
    document.title = "Frostico Venue Finder CRM";
  }, []);

  return (
    <div
      className="fixed inset-0 bg-white"
      data-testid="locations-crm-container"
    >
      <iframe
        src="/locations.html"
        title="Frostico Venue Finder CRM"
        data-testid="locations-crm-iframe"
        className="absolute inset-0 w-full h-full border-0"
      />
    </div>
  );
}
